import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import messages from "./local";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: messages,
    fallbackLng: "zh",
    lng: "zh",
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["navigator", "htmlTag"],
      caches: [],
    },
  });

export default i18n;